import { Building2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useNetwork } from '@/contexts/NetworkContext';

// Telas com barra de filtros (Dashboard, Reports) mostram o seletor junto de
// "Todos os domínios" e das datas; nelas o do topo some para não duplicar.
export const ROTAS_COM_CONTA_NO_FILTRO = ['/dashboard', '/reports'];

interface Props {
    // 'topo': ao lado do sino, com rótulo. 'filtro': mesmo tamanho dos outros
    // filtros da barra.
    variant?: 'topo' | 'filtro';
}

// Seletor de conta GAM. Sempre "Nome - ID".
export default function NetworkSelector({ variant = 'topo' }: Props) {
    const { networks, selected, setSelected } = useNetwork();

    if (networks.length === 0) return null;

    if (variant === 'filtro') {
        return (
            <Select value={selected ?? undefined} onValueChange={setSelected}>
                <SelectTrigger
                    className="h-auto w-auto min-w-[220px] gap-2 px-3 py-1.5 bg-white border-gray-300 rounded-lg hover:border-blue-400 text-sm font-medium text-gray-700"
                    aria-label="Conta GAM"
                    title="Conta GAM"
                >
                    <Building2 className="h-4 w-4 text-gray-500 flex-shrink-0" />
                    <SelectValue placeholder="Conta GAM" />
                </SelectTrigger>
                <SelectContent>
                    {networks.map((n) => (
                        <SelectItem key={n.network_code} value={n.network_code}>
                            {n.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        );
    }

    return (
        <div className="flex items-center gap-2">
            <Building2 className="h-4 w-4 text-gray-500 hidden md:block" />
            <span className="text-xs font-medium text-gray-500 hidden md:block">Conta GAM</span>
            <Select value={selected ?? undefined} onValueChange={setSelected}>
                <SelectTrigger className="h-9 w-[260px] text-sm" aria-label="Conta GAM">
                    <SelectValue placeholder="Selecione a conta" />
                </SelectTrigger>
                <SelectContent>
                    {networks.map((n) => (
                        <SelectItem key={n.network_code} value={n.network_code}>
                            {n.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
